import { render, staticRenderFns } from "./CalendarSync.vue?vue&type=template&id=0089e30e&lang=pug&"
import script from "./CalendarSync.vue?vue&type=script&lang=js&"
export * from "./CalendarSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports